import DataEngine from './DataEngine';

function createDataEngine (opts) {
    const {
        CustomComponentDataEngine: ComponentDataEngine = DataEngine
    } = opts;

    return new ComponentDataEngine(opts);
}

export default createDataEngine;
